import React from "react";
import {
  Modal,
  message,
  Upload,
  Form,
  Icon,
  Input,
  Select,
  Popconfirm,
  Button,
} from "antd";
import _ from "lodash";
import Services from "../../../services/categories";
import CategoryFormHelper from "./CategoryFormHelper";

// select-option
const Option = Select.Option;

//   upload-script start
const props = {
  name: "file",
  action: "//jsonplaceholder.typicode.com/posts/",
  headers: {
    authorization: "authorization-text",
  },
  onChange(info) {
    if (info.file.status !== "uploading") {
    }
    if (info.file.status === "done") {
      message.success(`${info.file.name} file uploaded successfully`);
    } else if (info.file.status === "error") {
      message.error(`${info.file.name} file upload failed.`);
    }
  },
};
//   upload-script end
let PreviewFromLink = {
  _id: "",
  uid: "",
  name: "",
  status: "done",
  response: "ok",
  url: "",
};

class BannerForm extends React.Component {
  // form-scripts start
  handleFormLayoutChange = (e) => {
    this.setState({ formLayout: e.target.value });
  };

  constructor() {
    super();
    this.state = {
      formLayout: "horizontal",
      previewVisible: false,
      addOption: false,
      visible: false,
      addItem: false,
      previewImage: "",
      banner: { title: [], url: [], fields: [], _id: [] },
      fileList: [],
      imageFiles: [],
      filteredInfo: null,
      sortedInfo: null,
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { editFormBanners } = this.props;
    if (!_.isEqual(prevProps.editFormBanners, editFormBanners)) {
      if (editFormBanners?.length) {
        const title = [], url = [], fields = [], fileList = [], _id = [];
        const formattedBannerData = editFormBanners?.map((banner) => {
          _id.push(banner?._id);
          title.push(banner?.text);
          fields.push("");
          url.push(banner?.url);
          fileList.push([
            {
              ...PreviewFromLink,
              _id: banner?._id,
              uid: banner?.image,
              name: banner?.name,
              url: `/api/util/image?key=${banner?.image}`,
            },
          ]);
        });
        this.setState({
          banner: { title, url, fields, _id },
          fileList,
        });
      }
    }
  }
  // Modal-scripts start
  showModal = () => {
    this.setState({
      visible: true,
    });
  };
  handleOk = (e) => {
    this.setState({
      visible: false,
    });
  };
  addItem = (e) => {
    this.setState({
      addItem: !this.state.addItem,
    });
  };
  addOption = (e) => {
    this.setState({
      addOption: !this.state.addOption,
    });
  };
  handleCancel = (e) => {
    this.setState({
      visible: false,
    });
  };
  // Modal-scripts end

  // pictureUpload scripts start

  handleCancel = () => this.setState({ previewVisible: false });

  handlePreview = (file) => {
    this.setState({
      previewImage: file.url || file.thumbUrl,
      previewVisible: true,
    });
  };
  handleRemove = (file, i) => {
    this.setState((prev) => {
      if (
        JSON.stringify(prev.imageFiles[i]?.uid) === JSON.stringify(file?.uid)
      ) {
        // prev.imageFiles.splice(i, 1);
        prev.imageFiles[i] = null;
      }
      delete prev.fileList[i];
      return { ...prev };
    });
  };
  handleUploadBegin = (file, i) => {
    this.setState((prev) => {
      prev.imageFiles[i] = file;
      return {
        imageFiles: prev.imageFiles,
      };
    });
  };
  handleChange = (e, index) => {
    this.setState((prev) => {
      prev.fileList[index] = e.fileList;
      return { fileList: prev.fileList };
    });
  };

  customRequest = ({ file, onSuccess }) => {
    if (file.status !== "uploading") {
    }
    if (file.status === "done") {
      message.success(`${file.name} file uploaded successfully`);
    } else if (file.status === "error") {
      message.error(`${file.name} file upload failed.`);
    }
    setTimeout(() => onSuccess("ok"), 0);
  };
  // pictureUpload scripts End
  columnGenerator = (id) => {
    return (
      <React.Fragment>
        <div className="ant-row" key={id}>
          <div className="ant-col-md-12">
            <Input type="text" placeholder="Add Title" />
          </div>

          <div className="ant-col-md-12">
            <Input type="text" placeholder="Add URL" />
          </div>
        </div>
        <br />
      </React.Fragment>
    );
  };

  _renderBanner = (i) => {
    const addTitle = (e) => {
      e.persist();
      this.setState((prev) => {
        prev.banner.title[i] = e.target.value;
        return {
          banner: prev.banner,
        };
      });
    };
    const addUrl = async (e) => {
      e.persist();
      this.setState((prev) => {
        prev.banner.url[i] = e.target.value;
        return {
          banner: prev.banner,
        };
      });
    };
    const { previewVisible, previewImage, fileList } = this.state;
    const uploadButton = (
      <div>
        <Icon type="plus" />
        <div className="ant-upload-text">Upload</div>
      </div>
    );
    return (
      <div className="ant-row" key={"Banner_" + i}>
        <div className="ant-col-md-8">
          <Input
            required
            type="text"
            placeholder="Add Title"
            onChange={addTitle.bind(this)}
            value={this.state.banner.title[i]}
          />
        </div>

        <div className="ant-col-md-8">
          <Input
            type="url"
            placeholder="Add URL"
            value={this.state.banner.url[i]}
            onChange={addUrl.bind(this)}
          />
        </div>

        <div className="ant-col-md-4 upload-img-main">
          <Upload
            listType="picture-card"
            fileList={fileList[i]}
            onPreview={this.handlePreview}
            customRequest={this.customRequest}
            beforeUpload={(file) => this.handleUploadBegin(file, i)}
            onChange={(e) => this.handleChange(e, i)}
            onRemove={(file) => this.handleRemove(file, i)}
            accept="image/jpeg, image/png"
          >
            {fileList[i]?.length ? null : uploadButton}
          </Upload>
          <Modal
            visible={previewVisible}
            footer={null}
            onCancel={this.handleCancel}
          >
            <img alt="example" style={{ width: "100%" }} src={previewImage} />
          </Modal>
        </div>
        <div className="ant-col-md-4 rite-btn">
          <div className="action-btn">
            <a href="" title="Delete">
              <Popconfirm
                title="Are you sure delete this ?"
                onConfirm={() => {
                  this.setState((prev) => {
                    Services.removeBanner(this.state.banner._id[i])
                    delete prev.banner?.fields[i];
                    delete prev.fileList[i];
                    return { banner: prev.banner, fileList: prev.fileList };
                  });
                }}
                onCancel={() => { }}
                okText="Yes"
                cancelText="No"
              >
                <span className="gx-link" title="Delete">
                  <i class="icon icon-trash"></i>
                </span>
              </Popconfirm>
            </a>
          </div>
        </div>
      </div>
    );
  };
  render() {
    const { formLayout } = this.state;

    // MULTIPLE-scripts start
    const children = [];
    for (let i = 1; i < 10; i++) {
      children.push(<Option key={i.toString(36) + i}>{"test"}</Option>);
    }

    // MULTIPLE-scripts End

    // Sort-Table-Scripts-Start
    let { sortedInfo, filteredInfo } = this.state;
    sortedInfo = sortedInfo || {};
    filteredInfo = filteredInfo || {};

    // sort-table-scripts-End

    // BannerState Setter Start
    CategoryFormHelper.setBannerState({
      banner: this.state.banner,
      images: this.state.imageFiles,
    });
    // BannerState Setter End

    return (
      <Form>
        <div className="ant-row hd-title gx-m-0">
          <div className="ant-col-md-12">
            <h1>Manage Banners</h1>
          </div>
          <div className="ant-col-md-12 rite-btn">
            <Button
              type="primary"
              className="color-white"
              onClick={() => {
                this.setState((prev) => {
                  prev.banner.fields.push("");
                  return { banner: prev.banner };
                });
              }}
            >
              <i class="icon icon-add"></i> Add
            </Button>
          </div>
        </div>

        <div className="ant-row gx-mt-4">
          <div className="ant-col-md-24">
            <div className="item-detail-edit-box">
              {this.state.banner?.fields?.map((item, index) => {
                return this._renderBanner(index);
              })}
            </div>
          </div>
        </div>
      </Form>
    );
  }
}
export default BannerForm;
